import { useCallback } from "react";

const SEEN_NOTIFICATION_KEY = "seenNotifications";

export const useSeenNotifications = () => {
  const getSeenNotifications = useCallback(() => {
    try {
      const data = localStorage.getItem(SEEN_NOTIFICATION_KEY);
      return data ? JSON.parse(data) : [];
    } catch (err) {
      console.error("Error reading seen notifications", err);
      return [];
    }
  }, []);

  const hasSeen = useCallback(
    (id) => getSeenNotifications().includes(id),
    [getSeenNotifications]
  );

  const markAsSeen = useCallback(
    (ids) => {
      try {
        const seen = new Set(getSeenNotifications());
        const newIds = Array.isArray(ids) ? ids : [ids];
        newIds.forEach((id) => seen.add(id));
        localStorage.setItem(SEEN_NOTIFICATION_KEY, JSON.stringify([...seen]));
      } catch (err) {
        console.error("Error saving seen notifications", err);
      }
    },
    [getSeenNotifications]
  );

  const syncSeenWithServer = useCallback(
    (serverTaskIds) => {
      try {
        const seen = new Set(getSeenNotifications());
        const serverIds = new Set(serverTaskIds);
        const filteredSeen = [...seen].filter((id) => serverIds.has(id));
        localStorage.setItem(
          SEEN_NOTIFICATION_KEY,
          JSON.stringify(filteredSeen)
        );
      } catch (err) {
        console.error("Error syncing seen notifications", err);
      }
    },
    [getSeenNotifications]
  );

  const clearSeenNotifications = useCallback(() => {
    try {
      localStorage.removeItem(SEEN_NOTIFICATION_KEY);
    } catch (err) {
      console.error("Error clearing seen notifications", err);
    }
  }, []);

  return {
    getSeenNotifications,
    hasSeen,
    markAsSeen,
    syncSeenWithServer,
    clearSeenNotifications,
  };
};
